import { PlannedMaintenanceDeviceDto } from "./planned-maintenance-device.dto";
import { PlannedMaintenanceServiceDto } from "./planned-maintenance-service.dto";

export class PlannedMaintenanceDto {
    plannedMaintenanceId: number;
    maintenanceId: number;
    maintenanceName: string;
    plannedDate: Date;
    requestId: number;
    agreementId: number;

    plannedMaintenanceServices: PlannedMaintenanceServiceDto[] = [];
    plannedMaintenanceDevices: PlannedMaintenanceDeviceDto[] = [];
}